import {AppCrmBoardWidgetComponent} from "../components/crm-board-widget/crm-board-widget.component";
import {
    AppCrmCalendarWidgetComponent
} from "../components/crm-calendar-widget/crm-calendar-widget.component";
import {AppCrmTasksWidgetComponent} from "../components/crm-tasks-widget/crm-tasks-widget.component";
import {
    AppCrmTaskFilterWidgetComponent
} from "../components/crm-task-filter-widget/crm-task-filter-widget.component";
import {AppEdiFilesWidgetComponent} from "../components/edi-files-widget/edi-files-widget.component";
import {
    AppEtfContractFilterWidgetComponent
} from "../components/etf-contract-filter-widget/etf-contract-filter-widget.component";
import {
    AppEdiFilesWidgetSettingsComponent
} from "../components/edi-files-widget/setting/edi-files-widget.settings.component";
import {
    AppContractFilterWidgetSettingsComponent
} from "../components/etf-contract-filter-widget/setting/etf-contract-filter-widget.settings.component";
import {
    AppTaskFilterWidgetSettingsComponent
} from "../components/crm-task-filter-widget/setting/crm-task-filter-widget.settings.component";
import {
    AppBoardWidgetSettingsComponent
} from "../components/crm-board-widget/setting/crm-board-widget.settings.component";
import {
    AppTasksWidgetSettingsComponent
} from "../components/crm-tasks-widget/setting/crm-tasks-widget.settings.component";
import {TaskBoardModel} from "../../../models/tasktable.model";
import {ITaskModelResponse, TaskModel} from "../../../models/task.model";
import {
    AppCRMCalendarWidgetSettingsComponent
} from "../components/crm-calendar-widget/setting/crm-calendar-widget.settings.component";
import {AppEtfBillWidgetComponent} from "../components/etf-bill-widget/etf-bill-widget.component";
import {
    AppEtfBillWidgetSettingsComponent
} from "../components/etf-bill-widget/setting/etf-bill-widget.settings.component";
import {AppEtfContractTableWidgetComponent} from "../components/etf-contract-table-widget/etf-contract-table-widget.component";

export type TWidgetGroupTypes = 'CRM' | 'EDI' | 'EFT'

export const WIDGET_TYPES = {
    WIDGET_CRM_TASKS: 'CRM',
    WIDGET_CRM_BOARD: 'CRM',
    WIDGET_CRM_TASK_FILTER: 'CRM',
    WIDGET_CRM_TASK_CALENDAR: 'CRM',
    WIDGET_EDI_FILES: 'EDI',
    WIDGET_EFT_CONTRACT_FILTER: 'EFT',
    WIDGET_EFT_CONTRACT_TABLE: 'EFT',
    WIDGET_EFT_BILL: 'EFT',
} as const;
export type TWidgetKeys = keyof typeof WIDGET_TYPES

export type TWidgetKeysSettings = `${TWidgetKeys}_SETTINGS`
export const WIDGET_COMPONENTS = new Map<TWidgetKeys | TWidgetKeysSettings, IWidgetsComponent>([
    ['WIDGET_CRM_BOARD', {component: AppCrmBoardWidgetComponent}],
    ['WIDGET_CRM_BOARD_SETTINGS', {
        component: AppBoardWidgetSettingsComponent, dialogOptions: {
            height: '80%',
            width: '50vw',
            minHeight: '200px',
            minWidth: '50vw',
            maxWidth: '100%'
        }
    }],
    ['WIDGET_CRM_TASK_CALENDAR', {component: AppCrmCalendarWidgetComponent}],
    ['WIDGET_CRM_TASK_CALENDAR_SETTINGS', {
        component: AppCRMCalendarWidgetSettingsComponent, dialogOptions: {
            height: '80%',
            width: '50vw',
            minHeight: '200px',
            minWidth: '50vw',
            maxWidth: '100%'
        }
    }],
    ['WIDGET_CRM_TASK_FILTER', {component: AppCrmTaskFilterWidgetComponent}],
    ['WIDGET_CRM_TASK_FILTER_SETTINGS', {
        component: AppTaskFilterWidgetSettingsComponent, dialogOptions: {
            height: '80%',
            width: '50vw',
            minHeight: '200px',
            minWidth: '50vw', maxWidth: '100%'
        }
    }],
    ['WIDGET_CRM_TASKS', {component: AppCrmTasksWidgetComponent}],
    ['WIDGET_CRM_TASKS_SETTINGS', {
        component: AppTasksWidgetSettingsComponent, dialogOptions: {
            height: '80%',
            width: '50vw',
            minHeight: '200px',
            minWidth: '50vw',
            maxWidth: '100%'
        }
    }],
    ['WIDGET_EDI_FILES', {component: AppEdiFilesWidgetComponent}],
    ['WIDGET_EDI_FILES_SETTINGS', {
        component: AppEdiFilesWidgetSettingsComponent, dialogOptions: {
            height: '30%',
            width: '30%',
            minHeight: '200px',
            minWidth: '200px'
        }
    }],
    ['WIDGET_EFT_CONTRACT_FILTER', {component: AppEtfContractFilterWidgetComponent}],
    ['WIDGET_EFT_CONTRACT_FILTER_SETTINGS', {
        component: AppContractFilterWidgetSettingsComponent, dialogOptions: {
            height: '30%',
            width: '30%',
            minHeight: '200px',
            minWidth: '200px'
        }
    }],
    ['WIDGET_EFT_CONTRACT_TABLE', {component: AppEtfContractTableWidgetComponent}],
    ['WIDGET_EFT_CONTRACT_TABLE_SETTINGS', {
        component: AppContractFilterWidgetSettingsComponent, dialogOptions: {
            height: '30%',
            width: '30%',
            minHeight: '200px',
            minWidth: '200px'
        }
    }],
    ['WIDGET_EFT_BILL', {component: AppEtfBillWidgetComponent}],
    ['WIDGET_EFT_BILL_SETTINGS', {
        component: AppEtfBillWidgetSettingsComponent, dialogOptions: {
            height: '30%',
            width: '30%',
            minHeight: '200px',
            minWidth: '200px'
        }
    }]
])

export interface IWidgetModelBase {
    description: string;
    height: number;
    width: number;
    id: number;
    title: string;
    options_dict: any;
    owner_guid: string;
    screen_x: number;
    screen_y: number;
    widget_key: TWidgetKeys | null;
    name?: string,
    component?: any;
    content?: any;
    style?: any;
    settingsComponent?: any,
    widget_type?: string,
    new_widget?: boolean,
    zIndex?: string,
    allowEditTitle?: boolean
}

export interface WidgetModel extends IWidgetModelBase {
    content?: any;
}

export interface ICRMTasksContentWidgetModel extends ITaskModelResponse {
    colonsSettings: any,
    dashes: TaskBoardModel[],
}

export interface ICRMTasksWidgetModel extends IWidgetModelBase {
    content: ICRMTasksContentWidgetModel
}

type TCRMCalendarContent = Record<string, TaskModel[]>

export interface ICRMTasksCalendarWidgetModel extends IWidgetModelBase {
    content: TCRMCalendarContent
}

/* export type TWidgetNew = Pick<WidgetModel, 'title'|'height'|'width'|'screen_x'|'screen_y'|'widget_key'|'widget_type'>  */
export interface WidgetKeyModel {
    description: string;
    key: string;
    name: string;
}

export interface IWidgetsComponent {
    component: any,
    dialogOptions?: {
        height?: string,
        width?: string,
        maxHeight?: string,
        minHeight?: string,
        maxWidth?: string
        minWidth?: string
    }
}

export interface IWidgetModelCreateResponse {
    message: string,
    widget: WidgetModel
}

export const DEFAULT_SETTINGS_DIALOG = {
    height: '60%',
    maxHeight: '100%',
    width: '30%',
    maxWidth: '100vw'
}
